import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="28.801" height="28.801" viewBox="0 0 28.801 28.801" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M28.801 2.057L26.743 0 14.4 12.343 2.058 0 0 2.057 12.343 14.4 0 26.744l2.058 2.057L14.4 16.458l12.343 12.343 2.058-2.057L16.457 14.4z" /></svg>);